import React from 'react';

import {Box, Divider, Grid, Paper, Skeleton, Stack} from 'views/components';

/**
 * Mimics the cards to be used as a skeleton when data is loading
 * @return {React.JSX.Element}
 */
const JobDetailSkeleton = () => {
  return (
    <Grid size={{xs: 12, lg: 8}}>
      <Stack spacing={2.25} sx={{maxWidth: 560}}>
        {/* Location title */}
        <Skeleton variant="text" width="55%" height={32} />

        {/* Pay & Hours */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={110} />
          </Stack>

          <Stack direction="row" justifyContent="space-between" sx={{mb: 1.25}}>
            <Box>
              <Skeleton variant="text" width={140} height={28} />
              <Skeleton variant="text" width={80} />
            </Box>
            <Box sx={{textAlign: 'right'}}>
              <Skeleton variant="text" width={110} height={28} />
              <Skeleton variant="text" width={70} />
            </Box>
          </Stack>

          <Skeleton variant="rounded" height={40} sx={{borderRadius: 2}} />
        </Paper>

        {/* Required Days */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={120} />
          </Stack>

          <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
            {
              Array.from({length: 6}).map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  width={80 + (i % 3) * 20}
                  height={28}
                  sx={{borderRadius: 2}}
                />
              ))
            }
          </Box>
        </Paper>

        {/* About this role */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={130} />
          </Stack>

          <Stack spacing={0.75}>
            <Skeleton variant="text" width="95%" />
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="80%" />
          </Stack>
        </Paper>

        {/* Expected start date */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={160} />
          </Stack>
          <Skeleton variant="text" width="45%" />
        </Paper>

        {/* Location */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={90} />
          </Stack>
          <Skeleton variant="text" width="60%" />
        </Paper>

        {/* Care needs */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={100} />
          </Stack>

          <Stack spacing={0.5}>
            {
              Array.from({length: 3}).map((_, i) => (
                <Skeleton key={i} variant="text" width={`${85 - i * 10}%`} />
              ))
            }
          </Stack>
        </Paper>

        {/* Requirements */}
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width={120} />
          </Stack>

          <Skeleton variant="text" width={170} />
          <Stack spacing={0.5} sx={{mt: 0.75}}>
            <Skeleton variant="text" width="70%" />
            <Skeleton variant="text" width="55%" />
          </Stack>

          <Divider sx={{my: 1.25}} />

          <Skeleton variant="text" width={150} />
          <Stack spacing={0.5} sx={{mt: 0.75}}>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="50%" />
          </Stack>
        </Paper>
      </Stack>
    </Grid>
  );
};

export default JobDetailSkeleton;
